var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "terms_condition" } }, [
    _c(
      "form",
      { attrs: { id: "tnc-form", "data-abide": "", novalidate: "" } },
      [
        _c("attachments", {
          attrs: { files: _vm.files, noHighlight: true, zipName: _vm.zipName },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isContractorView,
                expression: "isContractorView",
              },
            ],
          },
          [
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _vm.tncChecked.length < 1
                  ? _c(
                      "div",
                      {
                        staticClass: "errorTab",
                        staticStyle: { "min-height": "30px" },
                      },
                      [
                        _c("input", {
                          attrs: {
                            id: "no-tnc-exception-input",
                            type: "checkbox",
                            required: "",
                          },
                          domProps: { value: false },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return function (event) {
                                return false
                              }.apply(null, arguments)
                            },
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.tncChecked, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: "tnc-key-" + index,
                      staticClass: "tnc-item",
                      class: {
                        "tnc-item-last": index === _vm.lastIndex,
                        "has-checkbox": _vm.editView,
                      },
                    },
                    [
                      _vm.isTender || !_vm.tncItemList[index].itqExclude
                        ? [
                            _vm.editView
                              ? _c("input", {
                                  attrs: {
                                    id: "tnc-agree" + index,
                                    type: "checkbox",
                                    required: "",
                                  },
                                  domProps: { value: item.checked },
                                  on: {
                                    change: function (event) {
                                      return _vm.updateTncCheckedValue(
                                        index,
                                        event.target.checked
                                      )
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "tender-font",
                              class: {
                                errorTab: !item.checked && _vm.checkForm,
                              },
                              attrs: {
                                for: _vm.editView ? "tnc-agree" + index : "",
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.tncItemList[index].content
                                ),
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _vm.isOldTerm
                  ? _c(
                      "div",
                      {
                        staticClass: "clearfix tnc-total-fee",
                        class: { "has-checkbox": _vm.editView },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "tender-currency",
                            class: {
                              errorTab:
                                _vm.tncChecked.length > 0 &&
                                !_vm.tncChecked[_vm.lastIndex].checked &&
                                _vm.checkForm,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.currencyCode) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "tender-total-fee",
                            class: {
                              errorTab:
                                _vm.tncChecked.length > 0 &&
                                !_vm.tncChecked[_vm.lastIndex].checked &&
                                _vm.checkForm,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.currencyFormatter.format(
                                    _vm.totalFee,
                                    "USD"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "general-items",
                    class: { "has-checkbox": _vm.editView },
                  },
                  [
                    _vm.projectStart
                      ? _c("label", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("tender.general.projectStart")
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.projectStart
                      ? [
                          _vm.isOldTerm
                            ? _c("p", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "tender.general.oldProjectStartDesc",
                                        { projectStart: _vm.projectStart }
                                      )
                                    ),
                                  },
                                }),
                              ])
                            : _c("p", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t(
                                        "tender.general.projectStartDesc",
                                        { projectStart: _vm.projectStart }
                                      )
                                    ),
                                  },
                                }),
                              ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShowAdditionalItems
                      ? _c("label", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("tender.general.optionalItems")
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "additionalItems-list" },
                      [
                        _vm._l(_vm.optionalItems, function (option) {
                          return [
                            option.selected
                              ? _c(
                                  "li",
                                  { key: option.name, staticClass: "row" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "additionalItems-label" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(option.name) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "additionalItems-text" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(option.value) +
                                            " " +
                                            _vm._s(option.text) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row tnc-name-position",
                    class: { "has-checkbox": _vm.editView },
                  },
                  [
                    _c("div", { staticClass: "column" }, [
                      _c("label", {
                        staticClass: "tender-font",
                        class: { "label-min-width": _vm.editView },
                        attrs: { for: "tnc-agree-name" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("tender.general.Name")),
                        },
                      }),
                      _vm._v(" "),
                      _vm.editView
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tncInfo.name,
                                expression: "tncInfo.name",
                              },
                            ],
                            staticClass: "tnc-input",
                            attrs: {
                              id: "tnc-agree-name",
                              type: "text",
                              required: "",
                            },
                            domProps: { value: _vm.tncInfo.name },
                            on: {
                              change: function ($event) {
                                return _vm.updateTnc()
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.tncInfo,
                                  "name",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.editView
                        ? _c(
                            "label",
                            {
                              staticClass: "tender-font",
                              attrs: { for: "tnc-agree-name" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.tncInfo.name) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column" }, [
                      _c("label", {
                        staticClass: "tender-font",
                        class: { "label-min-width": _vm.editView },
                        attrs: { for: "tnc-agree-position" },
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("tender.general.Position")),
                        },
                      }),
                      _vm._v(" "),
                      _vm.editView
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.tncInfo.position,
                                expression: "tncInfo.position",
                              },
                            ],
                            staticClass: "tnc-input",
                            attrs: {
                              id: "tnc-agree-position",
                              type: "text",
                              required: "",
                            },
                            domProps: { value: _vm.tncInfo.position },
                            on: {
                              change: function ($event) {
                                return _vm.updateTnc()
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.tncInfo,
                                  "position",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.editView
                        ? _c(
                            "label",
                            {
                              staticClass: "tender-font",
                              attrs: { for: "tnc-agree-position" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.tncInfo.position) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tncInfo.companyName,
                        expression: "tncInfo.companyName",
                      },
                    ],
                    staticClass: "row declaration-on-behalf",
                    class: { "has-checkbox": _vm.editView },
                  },
                  [
                    _c("div", { staticClass: "column" }, [
                      _c("label", { staticClass: "tender-font" }, [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("tender.general.onBehalfOf")
                            ),
                          },
                        }),
                        _vm._v(" " + _vm._s(_vm.tncInfo.companyName)),
                      ]),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }